// extracted by mini-css-extract-plugin
module.exports = {"searchInput":"AccountBalance_searchInput__4lkjM","balanceList":"AccountBalance_balanceList__T6aKl"};